export function ExpertReminder() {
  return <aside className="expert-reminder" aria-label="Use your own expertise">
    <strong>Use your own expertise</strong>
    <p>The request, brief, rubric and examples must reflect your own work and judgment. Do not use AI to do the work or produce examples. The coach can question and challenge your rubric, but it never writes it for you, and neither should any other AI tool.</p>
  </aside>
}
